








import { Component, Vue, Emit } from 'vue-property-decorator';
import { ALL_PENSION_UNIT_SELECTIONS } from '@/queries/PensionUnitSelection';
import PensionUnitSelectionForm from '@/components/PensionUnitSelection/PensionUnitSelectionForm.vue';
import { GQL_createPensionUnitSelectionVariables, GQL_createPensionUnitSelection } from '@/queries/__generated__/createPensionUnitSelection';
import { CURRENT_UNIT } from '@/queries/Application';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_pensionUnitSelections } from '@/queries/__generated__/pensionUnitSelections';
import gql from 'graphql-tag';

const CREATE_PENSION_UNIT_SELECTION = gql`
  mutation createPensionUnitSelection($pensionUnitSelection: PensionUnitSelectionCreate!) {
    createPensionUnitSelection(
      input: { pensionUnitSelection: $pensionUnitSelection }
    ) {
      pensionUnitSelection {
        id
        pensionUnit {
          id
          name
        }
        validFrom
        validTo

        isSentToAltinn
        minimalValidTo
      }
    }
  },
`;

@Component({
  components: {
    PensionUnitSelectionForm,
  },
})
export default class PensionUnitSelectionNew extends Vue {
  @SmartQuery<PensionUnitSelectionNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.unitId = data.currentUnit.id;
    },
  }) public currentUnit!: GQL_currentUnit_currentUnit;

  private CREATE_PENSION_UNIT_SELECTION = CREATE_PENSION_UNIT_SELECTION;
  private data: GQL_createPensionUnitSelectionVariables['pensionUnitSelection'] = {
    unitId: '',
    pensionUnitId: '',
    validFrom: '',
    validTo: '',
  };

  @Emit('pension-unit-selection-created')
  public addToCache(store: InMemoryCache, query: {data: GQL_createPensionUnitSelection }) {
    const data = (store.readQuery({ query: ALL_PENSION_UNIT_SELECTIONS }) as GQL_pensionUnitSelections);
    if (!data.currentUnit || !query.data.createPensionUnitSelection?.pensionUnitSelection) return;
    const pensionUnitSelection = query.data.createPensionUnitSelection!.pensionUnitSelection!;
    data.currentUnit.pensionUnitSelections.push(pensionUnitSelection);
    store.writeQuery({ query: ALL_PENSION_UNIT_SELECTIONS, data });
    return pensionUnitSelection;
  }
}
